import ViewStockTake from "../../../../components/@documents/stock_takes/ViewStockTake";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function StockTakeViewPage() {

    return (
        <ViewStockTake 
            routeType={routeTypes.workstation}
        />
    )
}